import { formatMinutes, getSpacing, idToColor, pn, Skeleton, Stack } from "@compass/core";
import { Chart, Export, Label, Legend, Series, Tooltip, ValueAxis, VisualRange } from "devextreme-react/chart";
import { HomeServiceDashboardRow } from "generated/openApi";

export const ServiceChart = (props: { rows: HomeServiceDashboardRow[] | undefined; loading: boolean }) => {
  return props.loading ? (
    <Stack direction="row" spacing="lg">
      <Skeleton variant="rounded" width={"70%"} height={300} />
      <Skeleton variant="rounded" width={"30%"} height={200} />
    </Stack>
  ) : (
    <Stack width="100%" p={getSpacing("md")}>
      <Chart
        id="chart"
        dataSource={props.rows}
        customizePoint={(args: any) => {
          return { color: idToColor(args.data.serviceTypeId) };
        }}
        onPointHoverChanged={(pointInfo: any) => {
          if (pointInfo.target.isHovered()) {
            pointInfo.target.showTooltip();
          } else {
            pointInfo.target.hideTooltip();
          }
        }}
      >
        <Series
          argumentField={pn<HomeServiceDashboardRow>("serviceType")}
          valueField={pn<HomeServiceDashboardRow>("totalStudents")}
          type="bar"
        ></Series>

        <Tooltip
          enabled={false}
          customizeTooltip={(arg) => {
            return {
              text:
                `${arg.point.data.serviceType}<br/>` +
                `Students: ${arg.point.data.totalStudents}<br/>` +
                `Total: ${formatMinutes(arg.point.data.totalDurationInMinutes)}`,
            };
          }}
        />

        <ValueAxis>
          <VisualRange startValue={0} />
          <Label customizeText={(arg) => `${arg.valueText}`} />
        </ValueAxis>
        <Legend visible={false} />
        <Export enabled={true} />
      </Chart>
    </Stack>
  );
};
